import { api } from "./api";

const SID_KEY = "mhc_session_id";
const UTM_KEY = "mhc_utm";

export function getSessionId() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

export function track(event, meta = {}) {
  try {
    api.post("/analytics/event", { event, session_id: getSessionId(), meta }).catch(() => {});
  } catch (e) {
    /* non-blocking */
  }
}

// Capture UTM params from the URL and persist them so they survive navigation
// (e.g. landing -> assessment) and are attached to the lead on submission.
export function captureUTM() {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "ref"].forEach((k) => {
    const v = p.get(k);
    if (v) utm[k] = v;
  });
  if (Object.keys(utm).length > 0) {
    localStorage.setItem(UTM_KEY, JSON.stringify(utm));
  }
  return utm;
}

export function getUTM() {
  captureUTM();
  try {
    return JSON.parse(localStorage.getItem(UTM_KEY) || "{}");
  } catch (e) {
    return {};
  }
}
